var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4 10.8001H6.49676L10.4484 6.8485C10.9176 6.3793 10.9176 5.6209 10.4484 5.1517C9.97916 4.6825 9.22076 4.6825 8.75156 5.1517L2.75156 11.1517C2.28236 11.6209 2.28236 12.3793 2.75156 12.8485L8.75156 18.8485C8.98556 19.0825 9.29276 19.2001 9.59996 19.2001C9.90716 19.2001 10.2144 19.0825 10.4484 18.8485C10.9176 18.3793 10.9176 17.6209 10.4484 17.1517L6.49676 13.2001H20.4C21.0636 13.2001 21.6 12.6625 21.6 12.0001C21.6 11.3377 21.0636 10.8001 20.4 10.8001",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.2099c0247e49ca252832f2e4f272213a.svg";
export { ForwardRef as ReactComponent };